import loginImage from "common/assets/login-image.png";

const loginStyles = (theme) => ({
  wrapper: {
    display: "grid",
    "-ms-grid-rows": "1fr 10fr 1fr",
    gridTemplate: `
    "header demo" 1fr
    "main demo" 10fr
    "footer footer" 1fr `,
    width: "100%",
    height: "100%",
  },
  header: {
    "-ms-grid-row": 1,
    "-ms-grid-column": 1,
    gridArea: "header",
    minWidth: "50vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: `${theme.spacing(4)}px 0`,
    paddingLeft: theme.spacing(19),
  },
  logo: {
    width: 200,
  },
  mainPanel: {
    "-ms-grid-row": 2,
    "-ms-grid-column": 1,
    gridArea: "main",
    minWidth: "50vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: "10%",
    paddingBottom: "10%",
  },
  paper: {
    padding: theme.spacing(3),
    width: 380,
    minHeight: 350,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    flexDirection: "column",
  },
  fallBack: {
    padding: theme.spacing(2, 0),
    minHeight: 270,
  },
  demoPanel: {
    "-ms-grid-row": 1,
    "-ms-grid-row-span": 2,
    "-ms-grid-column": 2,
    gridArea: "demo",
    minWidth: "50vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: `linear-gradient(to right, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)), url(${loginImage})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingRight: "20%",
    paddingBottom: "7%",
  },
  demoText: {
    width: 360,
  },
  demoButton: {
    backgroundColor: theme.palette.corporateGreen.main,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.corporateGreen.dark,
    },
    marginTop: theme.spacing(2),
    width: 180,
  },
  footer: {
    "-ms-grid-row": 3,
    "-ms-grid-column": 1,
    "-ms-grid-column-span": 2,
    gridArea: "footer",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(0, 10),
    "& *": {
      fontSize: "inherit",
    },
  },
  textGroup: {
    display: "flex",
    justifyContent: "space-evenly",
    "& :first-child": {
      marginRight: theme.spacing(3),
    },
  },
  centeredText: {
    textAlign: "center",
  },
  smallText: {
    fontSize: "0.9rem",
  },
  title: {
    letterSpacing: 0.81,
    fontSize: "2.25rem",
  },
  link: {
    color: "inherit",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  bold: {
    fontWeight: 900,
  },
  subtitle: {
    fontSize: "1.2rem",
  },
});

export default loginStyles;
